import { render, staticRenderFns } from "./prepay.vue?vue&type=template&id=a132d1aa&scoped=true&"
import script from "./prepay.vue?vue&type=script&lang=js&"
export * from "./prepay.vue?vue&type=script&lang=js&"
import style0 from "./prepay.vue?vue&type=style&index=0&id=a132d1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a132d1aa",
  null
  
)

export default component.exports